import {
  getBreadCrumbList,
  setTagNavListInLocalstorage,
  getMenuByRouter,
  getTagNavListFromLocalstorage,
  getHomeRoute,
  getNextRoute,
  routeHasExist,
  routeEqual,
  getRouteTitleHandled,
  localSave,
  localRead
} from "@/libs/util";
// import { saveErrorLogger } from '@/api/data'
import router from "@/router";
import routers from "@/router/routers";
import config from "@/config";

import { loadMenu } from "@/libs/router-util";
const { homeName } = config;

const closePage = (state, route) => {
  const nextRoute = getNextRoute(state.tagNavList, route);
  state.tagNavList = state.tagNavList.filter(item => {
    return !routeEqual(item, route);
  });
  router.push(nextRoute);
};

export default {
  state: {
    breadCrumbList: [],
    tagNavList: [],
    homeRoute: {},
    local: localRead("local"),
    errorList: [],
    hasReadErrorPage: false,
    menuList: [],
    remind: false,
    remindId: 0,
    matchedCityCode: [],
    cateVars: {},
    currentShipmentParams: {}
  },
  getters: {
    // menuList: (state, getters, rootState) => getMenuByRouter(routers, rootState.user.access),
    // menuList: (state, getters, rootState) =>
    //   getMenuByRouter(loadMenu(), rootState.user.access),
    menuList: (state, getters, rootState) =>
      getMenuByRouter(state.menuList, rootState.user.access),
    errorCount: state => state.errorList.length
  },
  mutations: {
    updateCateVars(state, payload) {
      state.cateVars = payload
    },
    updateMatchedCityCode(state, payload) {
      state.matchedCityCode = payload
    },
    updateMenuList(state, routes) {
      let add = {
        path: "*",
        name: "error_404",
        meta: {
          hideInMenu: true
        },
        component: () => import("@/view/error-page/404.vue")
      };
      routes.push(add);

      router.addRoutes(routes);
      state.menuList = routes;
      // router.options.rotues=routes
    },
    setModifyShipmentParams(state, params) {
      state.currentShipmentParams = params
    },
    setBreadCrumb(state, route) {
      state.breadCrumbList = getBreadCrumbList(route, state.homeRoute);
    },
    setHomeRoute(state, routes) {
      state.homeRoute = getHomeRoute(routes, homeName);
    },
    setTagNavList(state, list) {
      let tagList = [];
      if (list) {
        tagList = [...list];
      } else tagList = getTagNavListFromLocalstorage() || [];
      if (tagList[0] && tagList[0].name !== homeName) tagList.shift();
      let homeTagIndex = tagList.findIndex(item => item.name === homeName);
      if (homeTagIndex > 0) {
        let homeTag = tagList.splice(homeTagIndex, 1)[0];
        tagList.unshift(homeTag);
      }
      state.tagNavList = tagList;
      setTagNavListInLocalstorage([...tagList]);
    },
    closeTag(state, route) {
      let tag = state.tagNavList.filter(item => routeEqual(item, route));
      route = tag[0] ? tag[0] : null;
      if (!route) return;
      closePage(state, route);
    },
    addTag(state, { route, type = "unshift" }) {
      let router = getRouteTitleHandled(route);
      if (!routeHasExist(state.tagNavList, router)) {
        if (type === "push") state.tagNavList.push(router);
        else {
          if (router.name === homeName) state.tagNavList.unshift(router);
          else state.tagNavList.splice(1, 0, router);
        }
        setTagNavListInLocalstorage([...state.tagNavList]);
      }
    },
    setLocal(state, { lang, that, isReload }) {
      localSave("local", lang);
      state.local = lang;
      if (isReload) {
        that.reload();
      }
    },
    addError(state, error) {
      state.errorList.push(error);
    },
    setHasReadErrorLoggerStatus(state, status = true) {
      state.hasReadErrorPage = status;
    },
    remindFun(state, remind) {
      state.remind = remind;
    },
    remindIdFun(state, remind) {
      state.remindId = remind;
    }
  },
  actions: {
    addErrorLog({ commit, rootState }, info) {
      if (!window.location.href.includes("error_logger_page"))
        commit("setHasReadErrorLoggerStatus", false);
      // saveErrorLogger 已废弃（见 @/api/data），此处不可再调用，否则会抛
      // TypeError 并被 errorHandler 的 nextTick 回调再次捕获，形成无限微任务死循环（prod 下 CPU 100%）
      const { user = {} } = rootState;
      const { token, userId, userName } = user;
      let data = {
        ...info,
        time: Date.parse(new Date()),
        token,
        userId,
        userName
      };
      commit("addError", data);
    }
  }
};
